import {
	breakpoint,
	Button,
	Flex,
	Image,
	scale,
	Text,
} from "@capioweb/ui-components/"
import React from "react"
import { QBankImage } from "../../@types/CapioWeb/core"
import styled from "styled-components"
import { List } from "./List"
import {
	imageBlockDataToImageProps,
	sendCareerListBlockClickDataLayerPush,
} from "../../utils"

export interface Item {
	header: string
	href: string
	text: string
	location: string
}

interface WorkHereCardProps {
	cta?: {
		href: string
		text: string
	}
	image: QBankImage
	items: Item[]
}

const StyledContainer = styled(Flex)`
	border-radius: ${scale.px(3)};

	${breakpoint("l")`
			border-top-right-radius: ${scale.px(3)};
			border-bottom-left-radius: ${scale.px(3)};		
	`}
`
const StyledImage = styled(Image)`
	border-top-left-radius: ${scale.px(3)};
	border-top-right-radius: ${scale.px(3)};

	${breakpoint("l")`
			border-top-right-radius: 0;
			border-bottom-left-radius: ${scale.px(3)};		
	`}
`

export const WorkHereCard: React.FC<WorkHereCardProps> = ({
	cta,
	image,
	items,
}) => {
	const srcSetSizes = [{ width: 1000, breakpoint: 2560 }]
	return (
		<StyledContainer
			backgroundColor={"blue11"}
			flexDirection={{ _: "column", l: "row" }}
			width={"100%"}
		>
			<StyledContainer w={{ _: 1, l: 0.5 }} h={{ _: 30, l: 59 }}>
				<StyledImage
					{...imageBlockDataToImageProps(image, true, true, srcSetSizes)}
				/>
			</StyledContainer>
			<Flex
				flexBasis={{ l: "50%" }}
				p={{ _: 3, l: 6.5 }}
				flexDirection={"column"}
			>
				<List>
					{items.map((item, index) => {
						return (
							<List.Item
								href={item.href}
								key={index}
								text={item.text}
								location={item.location}
							>
								<Flex flexDirection={"column"}>
									<Text mb={0}>{item.header?.toUpperCase()}</Text>
									<Text fontWeight={"bold"} mb={0}>
										{item.text}
									</Text>
								</Flex>
							</List.Item>
						)
					})}
				</List>
				{cta && (
					<Flex flexDirection={{ _: "column", m: "row" }} pt={{ _: 3, m: 4 }}>
						<Button.Anchor
							href={cta.href}
							variant="navy"
							onClick={() =>
								sendCareerListBlockClickDataLayerPush("Se alla lediga jobb", "")
							}
						>
							{cta.text}
						</Button.Anchor>
					</Flex>
				)}
			</Flex>
		</StyledContainer>
	)
}
